import React from 'react';

const HearenField = ({ isPlaying, eqEnabled, notchEnabled }) => {
  const intensity = isPlaying ? 1 : 0.45;
  const eqBoost = eqEnabled ? 1 : 0.7;
  const notchBoost = notchEnabled ? 1.15 : 0.9;

  return (
    <div className="relative w-full h-64 overflow-hidden rounded-3xl bg-[#07101f] border border-white/5">
      
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, rgba(118, 148, 255, 0.62), rgba(40, 70, 160, 0.34) 35%, rgba(4, 8, 18, 0.95) 75%)',
          animation: isPlaying ? 'hearenPulse 7s ease-in-out infinite' : 'none',
          transform: `scale(${intensity * eqBoost})`,
        }}
      />

      <div
        className="absolute left-1/2 top-1/2 w-52 h-52 rounded-full blur-3xl"
        style={{
          background: notchEnabled
            ? 'rgba(168, 120, 255, 0.62)'
            : 'rgba(90, 140, 255, 0.48)',
          transform: 'translate(-50%, -50%)',
          animation: isPlaying ? 'hearenBreath 5.5s ease-in-out infinite' : 'none',
          opacity: intensity * notchBoost,
        }}
      />

      <div
        className="absolute left-1/2 top-1/2 w-32 h-32 rounded-full blur-2xl"
        style={{
          background: eqEnabled
            ? 'rgba(120, 255, 210, 0.42)'
            : 'rgba(255, 255, 255, 0.08)',
          transform: 'translate(-50%, -50%)',
          animation: isPlaying ? 'hearenCore 3.8s ease-in-out infinite' : 'none',
        }}
      />

      <style>{`
        @keyframes hearenPulse {
          0% { transform: scale(0.96); opacity: 0.72; }
          50% { transform: scale(1.08); opacity: 1; }
          100% { transform: scale(0.96); opacity: 0.72; }
        }

        @keyframes hearenBreath {
          0% { transform: translate(-50%, -50%) scale(0.85); opacity: 0.45; }
          50% { transform: translate(-50%, -50%) scale(1.25); opacity: 0.9; }
          100% { transform: translate(-50%, -50%) scale(0.85); opacity: 0.45; }
        }

        @keyframes hearenCore {
          0% { transform: translate(-50%, -50%) scale(0.9); }
          50% { transform: translate(-50%, -50%) scale(1.18); }
          100% { transform: translate(-50%, -50%) scale(0.9); }
        }
      `}</style>
    </div>
  );
};

export default HearenField;